import React from 'react'
import { Icon } from '@workboard/action-item';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import { displayTimeAsHrsMins, sanitize } from '../utils/common'
import ImgIconComp from './imgcomp'
import { hot } from 'react-hot-loader/root'
import { getAiTypeAttributeIconName } from '../board/utils';
import { EAiIssueTypeAttrNames } from '../board/types/ai.types';
import MeetingsService from '../apps/meetings/services/meetings';
import { getConversationData, showPace1on1, showPaceCheckIn } from '../apps/meetings/models/meeting';
import { PrintOKRSection } from './PrintOKRSection';
import { ConnectedOkrManager } from '../apps/meetings/context/ConnectedOkrManager';
import { MeetingPrintPaceSection } from './meetings/meetingPrintPaceSection';
import { CheckinsHeader } from './meetings/meetingPrintCheckinsHeader';
import StructuredReviewSummary from './meetings/StructuredReviewSummary';

const IconWrapper = styled.span``;

const AgendaAiDetailsWrapper = styled.div`
  display: flex;
  gap: 5px;
  width: 80px;
  svg {
    margin-top: ${(props) => (props.isTakeItem ? '2px' : '0px')};
  }
`;

const StateIcon = ({ type, value, name }) => {
  const iconName = getAiTypeAttributeIconName(type, name ?? EAiIssueTypeAttrNames.STATE, value);
  return <Icon name={iconName} width="15" height="15" />;
}

const SectionHeader = ({ title, iconId, displayDate }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '700', color: '#000000' }}>
        <ImgIconComp
          id={iconId}
          width="20"
          height="20"
          style={{ marginRight: '10px' }}
        />
        {title}
      </div>
      {displayDate && (
        <div style={{ marginLeft: 'auto', color: "#0A153799", fontWeight: 400, size: '14px', fontStyle: 'italic' }}>
          {`As of ${displayDate}`}
        </div>
      )}
    </div>
  );
};

class MeetingPrintViewComp extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      meetingObj: this.props.items.meeting,
      imageLogo: '',
      isConversationMeeting: false,
      conversationMeeting: null,
      showPace: false,
      showTeamOkrs: false,
      showPersonalOkrs: false,
      showKrsOnTeamOkrs: false,
      attendees: [],
      legacyData: null
    }
  }

  componentDidMount() {
    showLoaderWidget($("#content"));
    const _this = this
    let imageLogos = ''

    MeetingsService.getLogo().then((resp) => {
      imageLogos = resp?.data?.orgLogoPath || '';
      setTimeout(() => {
        _this.setState({
          imageLogo: imageLogos,
        })
      }, 10)
    });
    const { meeting } = this.props.items;
    MeetingsService.get(meeting.id).then((resp) => {

      const { conversationMeeting, isConversationMeeting } = getConversationData(resp?.data?.data);
      const {
        krsOnTeamOkrs,
        paceRatings,
        personalOkrs,
        teamOkrs
      } = conversationMeeting?.meetingTemplateOptions || {krsOnTeamOkrs: false, paceRatings: false, personalOkrs: false, teamOkrs: false};
      const pace1on1 = showPace1on1(resp?.data?.data);
      const paceCheckIn = showPaceCheckIn(paceRatings, conversationMeeting)
      this.setState({
        isConversationMeeting,
        conversationMeeting,
        showPace: pace1on1 || paceCheckIn,
        showTeamOkrs: Boolean(teamOkrs),
        showPersonalOkrs: Boolean(personalOkrs),
        showKrsOnTeamOkrs: Boolean(krsOnTeamOkrs),
        attendees: resp.data.data?.attendees || [],
        legacyData: resp.data.data?.legacyData || null,
        endDate: resp.data.data?.conversationMeetingData?.dueDate || null,
        completedAt: resp.data.data?.conversationMeetingData?.completedDate || null,
      })
    }).catch((err) => {
      console.error('Error in fetching meeting data', err);
    }).finally(() => {
      removeLoader();
    });
  }

  render() {
    const { t } = this.props;
    const { meeting } = this.props.items;
    const { dateDropdown } = this.props.items;
    const { selectedUser } = this.props.items;
    const { meeting_invitees } = this.props.items;
    const { meeting_takes } = this.props.items;
    const { meeting_topics } = this.props.items;
    const currentUsers = this.props.items.currentUser;
    const meetingTitle =
      meeting.type == 1
        ? ` ${currentUsers.fullName}'s 1on1 with ${selectedUser.firstname}`
        : ` Meeting:  ${meeting.name}`;
    const printSummaryMeeting = this.props.items.printMeeting == '1';

    let meetingTopicDecision = false;
    let meetingTakeDecision = false;
    let meetingTopicTakeD = false;

    if (typeof meeting_topics !== 'undefined' && meeting_topics.length > 0) {
      meeting_topics.map((top) => {
        if (top.tag == '3') {
          meetingTopicDecision = true
        }

        if (
          typeof top.topic_take !== 'undefined' &&
          top.topic_take.length > 0
        ) {
          top.topic_take.map((item) => {
            if (item.tag == '3') {
              meetingTopicTakeD = true
            }
          })
        }
      })
    }
    if (typeof meeting_takes !== 'undefined' && meeting_takes.length > 0) {
      meeting_takes.map((take) => {
        if (take.tag == '3') {
          meetingTakeDecision = true
        }
      })
    }
    const timeSpent = meeting.time_spent
    const meetingSpentTime = displayTimeAsHrsMins(timeSpent)
    let dropDateStr = ''
    let dropDayStr = ''
    dateDropdown.map((dropDate) => {
      if (dropDate.id == meeting.id) {
        dropDateStr = dropDate.name
        dropDayStr = dropDate.day
      }
    });

    return (
      <ConnectedOkrManager>
      <div className="meetingPrintSummaryDetail">
        {!this.state.isConversationMeeting && (
          <>
            <div>
              <div
                className={
                  !printSummaryMeeting ? 'meetingPublishTitle' : 'meetingPrintTitle'
                }
              >
                {meetingTitle}
              </div>
              <div className="woboLogo">
                <img
                  className="imageLogos"
                  src={this.state.imageLogo}
                  width="117px"
                  height="auto"
                />
              </div>
            </div>
            <div className="meetingPublishTimeDetails">
              {meeting.location != '' && (
                <div className="meetingPublishMember meetingPrintMember ">
                  {meeting.location}
                </div>
              )}
              <div
                className="meetingPublishDate meetingPrintMember "
                style={{ paddingLeft: '0px' }}
              >{`${dropDayStr} ${dropDateStr}`}</div>
              <div
                className="meetingPublishTime meetingPrintMember "
                style={{ paddingLeft: '0px' }}
              >
                {meetingSpentTime != '' ? 'Duration:' : ''}
                <strong>{meetingSpentTime}</strong>
              </div>
            </div>
          </>
        )}
        {this.state.isConversationMeeting && (
          <CheckinsHeader
            header={meeting?.name}
            status={this.state.conversationMeeting?.status}
            participant={this.state.conversationMeeting?.memberId}
            completedBy={this.state.conversationMeeting?.completedBy}
            completedByUser={this.state.conversationMeeting?.completedByUserId}
            completedAt={this.state.completedAt}
            startDate={this.state.conversationMeeting?.startDate}
            endDate={this.state.endDate}
            meeting_invitees={meeting_invitees}
            woboLogo={this.state.imageLogo}
          />
        )}
        <PrintOKRSection
          meeting={this.state.meetingObj}
          userId={currentUsers.id}
          attendees={this.state.attendees}
          showTeamOkrs={this.state.showTeamOkrs}
          showPersonalOkrs={this.state.showPersonalOkrs}
          showKrsOnTeamOkrs={this.state.showKrsOnTeamOkrs}
        />
        <div className="meetingDecision">
          {(meetingTakeDecision ||
            meetingTopicDecision ||
            meetingTopicTakeD) && (
            <div className="printMeetingAttendeeTitle">{t('DECISIONS')}</div>
          )}
          <div>
            {meeting_topics.map((items, index) =>
              items.tag == 3 ? (
                <div
                  data-sec="reltaketopic"
                  style={{
                    display:
                      items.access == 0 &&
                      meeting.type == 1 &&
                      items.added_by != currentUsers.id
                        ? 'none'
                        : '',
                  }}
                >
                  <div
                    className="agendaTakeAwaysData takeAwayFont"
                    data-test="topic"
                    data-tag={items.tag}
                    style={{
                      borderBottom:
                        items.description != '' && items.tag == 3
                          ? '0px solid #E1F3F8'
                          : '0',
                    }}
                  >
                    {
                      <div>
                        {items.tag == 3 && items.description != '' && (
                          <div>
                            <div className="agendaDescription">
                              <div className="agendaPublishImages">
                                <div
                                  className="takeAwayimage meeting-tag-options meeting-tag-bullet meetingTopicImage"
                                  data-id={items.id}
                                  data-tag={items.tag}
                                  data-type="take"
                                />
                              </div>
                              <div className="agendaPrintDescription">
                                <div
                                  className="agendaPrintDescription"
                                  dangerouslySetInnerHTML={{
                                    __html: sanitize(items.description),
                                  }}
                                />
                                <div className="agendaPrintDescriptionMember takeAwayDesc">{`${items.firstname} ${items.lastname}`}</div>
                                <div className="agendaDescriptionTime">
                                  {items.created_date}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {(items.files != '' ||
                          (typeof items.files !== 'undefined' &&
                            items.files.length > 0)) &&
                          items.tag == 3 &&
                          items.description != '' && (
                            <div class="topic-attachments">
                              <div class="attachments-heading">
                                {t('Decision Attachment/s')}
                              </div>
                              {items.files.map((file) => (
                                <div>
                                  <div
                                    className="meetingPublishAgendaDetails titleTopLevel"
                                    style={{ padding: '5px 0px' }}
                                  >
                                    <div className="agendaPublishImages">
                                      <div
                                        className="meeting-tag-options meeting-tag-bullet meetingTopicImage"
                                        data-tag="14"
                                        data-type="ai"
                                      />
                                    </div>
                                    <div className="printTopictext">
                                      {file.file_name}
                                    </div>
                                  </div>
                                  <div
                                    className="agendaDescriptionMember takeAwayDesc"
                                    style={{ marginLeft: '30px' }}
                                  >{`${items.firstname} ${items.lastname}`}</div>
                                  <div className="agendaDescriptionTime">
                                    {items.created_date}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                      </div>
                    }
                  </div>

                  {items.topic_take.map((take, index) => (
                    <div
                      className="agendaTakeAwaysData takeAwayFont"
                      data-test="takeR"
                      data-tag={take.tag}
                      style={{
                        borderBottom:
                          items.description != '' && take.tag == 3
                            ? '0px solid #E1F3F8'
                            : '0',
                        display:
                          take.tag != 3 &&
                          items.access == 0 &&
                          meeting.type == 1 &&
                          items.added_by != currentUser.id
                            ? 'none'
                            : '',
                      }}
                    >
                      {take.tag == 3 && take.description != '' && (
                        <div>
                          <div className="agendaPublishImages">
                            <div
                              className="takeAwayimage meeting-tag-options meeting-tag-bullet meetingTopicImage"
                              data-id={take.id}
                              data-tag={take.tag}
                              data-type="take"
                            >
                              {' '}
                            </div>
                          </div>
                          {take.description != '' && (
                            <div className="agendaPrintDescription">
                              <div
                                className="agendaPrintDescription takeAwayDesc"
                                dangerouslySetInnerHTML={{
                                  __html: sanitize(take.description),
                                }}
                              />
                              <div>
                                <div className="agendaPrintDescriptionMember takeAwayDesc">{`${take.firstname} ${take.lastname}`}</div>
                                <div className="agendaDescriptionTime">
                                  {take.created_date}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {(take.files != '' ||
                        (typeof take.files !== 'undefined' &&
                          take.files.length > 0)) &&
                        take.tag == 3 &&
                        take.description != '' && (
                          <div class="topic-attachments">
                            <div class="attachments-heading">
                              {t('Decision Attachment/s')}
                            </div>
                            {take.files.map((file) => (
                              <div>
                                <div
                                  className="meetingPublishAgendaDetails titleTopLevel"
                                  style={{ padding: '5px 0px' }}
                                >
                                  <div className="agendaPublishImages">
                                    <div
                                      className="meeting-tag-options meeting-tag-bullet meetingTopicImage"
                                      data-tag="14"
                                      data-type="ai"
                                    />
                                  </div>
                                  <div className="printTopictext">
                                    {file.file_name}
                                  </div>
                                </div>
                                <div
                                  className="agendaDescriptionMember takeAwayDesc"
                                  style={{ marginLeft: '30px' }}
                                >{`${take.firstname} ${take.lastname}`}</div>
                                <div className="agendaDescriptionTime">
                                  {take.created_date}
                                </div>
                              </div>
                            ))}{' '}
                          </div>
                        )}
                    </div>
                  ))}
                </div>
              ) : (
                <div
                  data-sec="reltake"
                  style={{
                    display:
                      items.access == 0 &&
                      meeting.type == 1 &&
                      items.added_by != currentUsers.id
                        ? 'none'
                        : '',
                  }}
                >
                  {items.topic_take.map(
                    (take, index) =>
                      take.tag == 3 &&
                      take.description != '' && (
                        <div
                          className="agendaTakeAwaysData takeAwayFont"
                          data-test="ntake"
                          data-tag={take.tag}
                          style={{
                            borderBottom:
                              take.description != ''
                                ? '0px solid #E1F3F8'
                                : '0',
                          }}
                        >
                          <div>
                            <div
                              className="agendaPublishImages takeAwayimage meeting-tag-options meeting-tag-bullet meetingTopicImage"
                              data-id={take.id}
                              data-tag={take.tag}
                              data-type="take"
                              style={{
                                backgroundPosition: 'left',
                                margin: '0px 16px 0 -3px',
                              }}
                            >
                              {' '}
                            </div>
                            <div className="agendaPrintDescription">
                              <div
                                className="agendaPrintDescription takeAwayDesc"
                                dangerouslySetInnerHTML={{
                                  __html: sanitize(take.description),
                                }}
                              />
                              <div className="agendaPrintDescriptionMember takeAwayDesc">{`${take.firstname} ${take.lastname}`}</div>
                              <div className="agendaDescriptionTime">
                                {take.created_date}
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                  )}
                </div>
              )
            )}
            {meeting_takes.map(
              (items, index) =>
                items.tag == 3 &&
                items.description != '' && (
                  <div
                    className="agendaTakeAwaysData takeAwayFont"
                    data-tag={items.tag}
                  >
                    <div data-sec="notake">
                      <div
                        className="agendaPublishImages takeAwayimage meeting-tag-options meeting-tag-bullet meetingTopicImage"
                        data-id={items.id}
                        data-tag={items.tag}
                        data-type="take"
                      >
                        {' '}
                      </div>
                      <div className="agendaPrintDescription">
                        <div
                          className="agendaPrintDescription takeAwayDesc"
                          dangerouslySetInnerHTML={{
                            __html: sanitize(items.description),
                          }}
                        />
                        <div className="agendaPrintDescriptionMember takeAwayDesc">{`${items.firstname} ${items.lastname}`}</div>
                        <div className="agendaDescriptionTime">
                          {items.created_date}
                        </div>
                      </div>
                    </div>
                  </div>
                )
            )}
          </div>
        </div>

        {meeting_topics.length > 0 && (
          <div className="meetingPrintAgenda">{t('AGENDA/TAKEAWAYS')}</div>
        )}
        {meeting_topics.map(
          (item, index) =>
            (item.description != '' ||
              (typeof item.topic_take !== 'undefined' &&
                item.topic_take.length > 0)) && (
              <div
                className="agendaTakeAwaysData"
                style={{
                  borderBottom:
                    item.description != '' ? '1px solid #D7DDE5' : '0',
                  display:
                    item.access == 0 &&
                    meeting.type == 1 &&
                    item.added_by != currentUsers.id
                      ? 'none'
                      : '',
                }}
              >
                {item.description != '' && (
                  <>
                    <div className="meetingPublishAgendaDetails titleTopLevel">
                      <div className="agendaPublishImages">
                        {item.wobo_type == 'ai' ? (
                          <IconWrapper>
                            <StateIcon type={item.wobo_data.type} value={item.wobo_data.state} />
                          </IconWrapper>
                        ) : (
                          <div
                            className="meeting-tag-options meeting-tag-bullet meetingTopicImage meeting-dec-img"
                            data-tag={
                              item.wobo_type == 'topic'
                                ? item.tag
                                : item.wobo_type_id
                            }
                            data-type={item.wobo_type}
                          />
                        )}
                      </div>
                      {item.wobo_type == 'attachment' ? (
                        <div className="printTopicDescription">
                          {item.description}
                        </div>
                      ) : (
                        <div className="printTopictext">
                          <div
                            className="printTopictext innerPrintTopicText"
                            dangerouslySetInnerHTML={{
                              __html: sanitize(item.description),
                            }}
                          />
                          {item.recurringTopic == 1 && (
                            <ImgIconComp
                              id="recurringTemp"
                              class="recuuringPic dispIB"
                              width="20"
                              height="20"
                            />
                          )}
                        </div>
                      )}
                      {item.wobo_type == 'workstream' && (
                        <div className="agendaPrintPercentageValue">
                          <div
                            className="publish-ws-health"
                            data-value={item.wobo_data.health}
                          />
                          <div
                            className="publish-ws-progress"
                            style={{
                              fontSize: '14px',
                              color: item.wobo_data.progress_color,
                            }}
                          >
                            {item.wobo_data.progress != ''
                              ? `${item.wobo_data.progress}%`
                              : '0%'}
                          </div>
                        </div>
                      )}
                      {item.wobo_type == 'objective' && (
                        <div
                          className="agendaPrintPercentageValue"
                          style={{
                            color: item.wobo_data.goal_percentage_color,
                          }}
                        >
                          {item.wobo_data.progress.indexOf('-1') >= 0 ||
                          item.wobo_data.progress < 0
                            ? '--'
                            : `${item.wobo_data.progress}%`}
                        </div>
                      )}
                      {item.wobo_type == 'ai' && (
                        <AgendaAiDetailsWrapper>
                          <IconWrapper>
                            <StateIcon
                              type={item.wobo_data.type}
                              name={EAiIssueTypeAttrNames.PRIORITY}
                              value={item.wobo_data.priority}
                            />
                          </IconWrapper>
                          <IconWrapper>
                            <StateIcon
                              type={item.wobo_data.type}
                              name={EAiIssueTypeAttrNames.RAG}
                              value={item.wobo_data.rag}
                            />
                          </IconWrapper>
                          <span
                            className="aiDueDate"
                            style={{ verticalAlign: 'super', fontSize: '10px' }}
                          >
                            {moment(item.wobo_data.due_date * 1000).format(
                              'MMM DD'
                            )}
                          </span>
                        </AgendaAiDetailsWrapper>
                      )}
                      {item.wobo_type == 'key_result' && (
                        <div
                          className="agendaPrintPercentageValue"
                          style={{
                            fontSize: '14px',
                            color: item.wobo_data.progress_color,
                          }}
                        >
                          {item.wobo_data.achieve_target_text}
                        </div>
                      )}
                    </div>
                    {item.wobo_type == 'topic' && (
                      <div
                        className="agendaPublishPeople"
                        style={{ marginLeft: '30px' }}
                      >
                        {`${item.firstname} ${item.lastname}`}{' '}
                        {item.created_date}
                      </div>
                    )}
                  </>
                )}
                {item.files != '' &&
                  typeof item.files !== 'undefined' &&
                  item.files.length > 0 && (
                    <div class="topic-attachments">
                      <div class="attachments-heading">{t("Topic Attachment/s")}</div>
                      {item.files.map((file) => (
                        <div>
                          <div
                            className="meetingPublishAgendaDetails titleTopLevel"
                            style={{ padding: '5px 0px' }}
                          >
                            <div className="agendaPublishImages">
                              <div
                                className="meeting-tag-options meeting-tag-bullet meetingTopicImage"
                                data-tag="14"
                                data-type="ai"
                              />
                            </div>
                            <div className="printTopictext">
                              {file.file_name}
                            </div>
                          </div>
                          <div
                            className="agendaDescriptionMember takeAwayDesc"
                            style={{ marginLeft: '30px' }}
                          >
                            {file.fullName}
                          </div>
                          <div className="agendaDescriptionTime">
                            {moment
                              .utc(file.create_at * 1000)
                              .format('hh:mm a MMM DD,YYYY')}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                {item.description != '' && (
                  <div className="meetingPublishAgendaDetails titleTopLevel">
                    <div className="agendaPublishImages" />
                    {item.wobo_type == 'key_result' && (
                      <div className="agendaPrintPeople">
                        {item.wobo_data.ownerName
                          ? item.wobo_data.ownerName
                          : ''}
                        {item.wobo_data.goalName
                          ? ` : ${item.wobo_data.goalName}`
                          : ''}
                      </div>
                    )}
                    {item.wobo_type == 'workstream' && (
                      <div className="agendaPrintPeople">
                        {item.wobo_data.wsLeadName
                          ? item.wobo_data.wsLeadName
                          : ''}{' '}
                        {item.wobo_data.teamName
                          ? ` : ${item.wobo_data.teamName}`
                          : ''}
                      </div>
                    )}
                    {item.wobo_type == 'objective' && (
                      <div className="agendaPrintPeople">
                        {item.wobo_data.ownerName
                          ? item.wobo_data.ownerName
                          : ''}
                        {item.wobo_data.teamName
                          ? ` : ${item.wobo_data.teamName}`
                          : ''}
                      </div>
                    )}
                    {item.wobo_type == 'topic' && (
                      <div className="agendaPublishPeople" />
                    )}
                    {item.wobo_type == 'ai' && (
                      <div className="agendaPrintPeople">
                        {item.wobo_data.wsName ? item.wobo_data.wsName : ''}
                        {item.wobo_data.ownerName
                          ? ` : ${item.wobo_data.ownerName}`
                          : ''}
                      </div>
                    )}
                    {item.wobo_type == 'attachment_link' && (
                      <div className="agendaPublishPeople">
                        {`${item.firstname} ${item.lastname}`}{' '}
                        {item.created_date}
                      </div>
                    )}
                  </div>
                )}
                {typeof item.topic_take !== 'undefined' &&
                item.topic_take.length > 0
                  ? item.topic_take.map((take) => (
                      <div>
                        <div
                          className="meetingPublishAgendaIndDetails"
                          style={{
                            marginLeft: item.description != '' ? '64px' : '0px',
                            borderBottom:
                              item.description != ''
                                ? '0px'
                                : '0px solid #E1F3F8',
                            paddingBottom:
                              item.description != '' ? '0px' : '10px',
                          }}
                        >
                          <div className="agendaPublishImages">
                            {take.state != null ? (
                              <IconWrapper>
                                <StateIcon type={take.wobo_data.type} value={take.wobo_data.state} />
                              </IconWrapper>
                            ) : (
                              <div
                                className="meeting-tag-options meeting-tag-bullet meetingTopicImage"
                                data-id={take.id}
                                data-tag={take.tag}
                                data-type="take"
                              />
                            )}
                          </div>
                          <div className="agendaPrintDescription">
                            {take.tag == 1 ? (
                              <div style={{ display: 'flex' }}>
                                <div
                                  className="agendaDescription"
                                  dangerouslySetInnerHTML={{
                                    __html: sanitize(take.description),
                                  }}
                                  style={{ flexGrow: 1 }}
                                />
                                  <AgendaAiDetailsWrapper isTakeItem={true}>
                                    <IconWrapper>
                                      <StateIcon
                                        type={take.wobo_data.type}
                                        name={EAiIssueTypeAttrNames.PRIORITY}
                                        value={take.wobo_data.priority}
                                      />
                                    </IconWrapper>
                                    <IconWrapper>
                                      <StateIcon
                                        type={take.wobo_data.type}
                                        name={EAiIssueTypeAttrNames.RAG}
                                        value={take.wobo_data.rag}
                                      />
                                    </IconWrapper>
                                    <span
                                      className="aiDueDate"
                                      style={{
                                        verticalAlign: 'super',
                                        fontSize: 10,
                                      }}
                                    >
                                      {moment(
                                        take.wobo_data.due_date * 1000
                                      ).format('MMM DD')}
                                    </span>
                                  </AgendaAiDetailsWrapper>
                              </div>
                            ) : (
                              <div
                                className="agendaDescription"
                                dangerouslySetInnerHTML={{
                                  __html: sanitize(take.description),
                                }}
                              />
                            )}
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {take.tag == 0 || take.tag == 3 ? (
                                <div className="agendaPrintDescriptionMember takeAwayDesc">
                                  {`${take.firstname} ${take.lastname}`}
                                </div>
                              ) : (
                                <div
                                  className="agendaPrintDescriptionMember takeAwayDesc"
                                  style={{ fontStyle: 'normal' }}
                                >
                                  {take.wobo_data != undefined && take.wobo_data.wsName
                                    ? `${take.wobo_data.wsName} : `
                                    : ''}
                                  {`${take.firstname} ${take.lastname}`}
                                </div>
                              )}
                              {take.tag == 0  || take.tag == 3 ? (
                              <div className="agendaDescriptionTime">
                                {take.created_date}
                              </div>
                            ) : (
                              <div
                                className="agendaDescriptionTime"
                                style={{ fontStyle: 'normal' }}
                              >
                                {take.created_date}
                              </div>
                            )}
                            </div>
                          </div>
                        </div>
                        {take.files != '' &&
                          typeof take.files !== 'undefined' &&
                          take.files.length > 0 && (
                            <div class="take-attachments">
                              <div class="attachments-heading">
                                {t("Takeaway Attachment/s")}
                              </div>
                              {take.files.map((file) => (
                                <div>
                                  <div
                                    className="meetingPublishAgendaIndDetails"
                                    style={{
                                      padding: '5px 0px',
                                    }}
                                  >
                                    <div className="agendaPublishImages">
                                      <div
                                        className="meeting-tag-options meeting-tag-bullet meetingTopicImage"
                                        data-tag="14"
                                        data-type="ai"
                                      />
                                    </div>
                                    <div
                                      className="printTopictext"
                                      style={{
                                        minWidth: '60%',
                                        maxWidth: '60%',
                                      }}
                                    >
                                      {file.file_name}
                                    </div>
                                  </div>
                                  <div className="agendaDescriptionMember takeAwayDesc">
                                    {`${take.firstname} ${take.lastname}`}
                                  </div>
                                  <div className="agendaDescriptionTime">
                                    {take.created_date}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                      </div>
                    ))
                  : ''}
              </div>
            )
        )}
        <div className={meeting_takes.length ? 'meetingPublishAgenda' : ''}>
          {meeting_takes.map((item, index) => (
            <div className="agendaTakeAwaysData takeAwayFont">
              <div
                className="agendaPublishImages takeAwayimage meeting-tag-options meeting-tag-bullet meetingTopicImage"
                data-id={item.id}
                data-tag={item.tag}
                data-type="take"
              >
                {' '}
              </div>
              <div className="agendaPrintDescription">
                <div
                  className="agendaPrintDescription takeAwayDesc"
                  dangerouslySetInnerHTML={{ __html: sanitize(item.description) }}
                />
                <div className="agendaPrintDescriptionMember takeAwayDesc">{`${item.firstname} ${item.lastname}`}</div>
                <div className="agendaDescriptionTime">{item.created_date}</div>
              </div>
            </div>
          ))}
        </div>
        {meeting.type != 1 && (
          <>
            <div className="meetingPublishAgendaDesc">{t("DESCRIPTION")}</div>
            <div className="meetingPublishTimeDetails meetingPrintText">
              <div dangerouslySetInnerHTML={{ __html: sanitize(meeting.objective) }} />
            </div>
          </>
        )}
        {this.state.isConversationMeeting && <StructuredReviewSummary meetingId={meeting.id} />}
        {this.state.showPace && (
         <>
          {this.state.isConversationMeeting && (
            <>
              <SectionHeader title={t('Participant Rating')} iconId={'paceIcon'} displayDate={this.state.conversationMeeting?.meetingPace?.paceAsOf} />
              <div style={{color: "#333943", fontWeight: 400, fontSize: "14px", font: 'Lato', marginLeft: 30, marginBottom: 30, marginTop: 5}}>
                {this.state.conversationMeeting?.meetingPace?.epa_coaching_text['header']['name']}
              </div>
            </>
            )}
            {!this.state.isConversationMeeting && (
              <>
                <SectionHeader title={t('Participant Rating')} iconId={'paceIcon'} displayDate={this.state.legacyData?.paceAsOf} />
                <div style={{color: "#333943", fontWeight: 400, font: 'Lato', fontSize: "14px", marginLeft: 30, marginBottom: 30, marginTop: 5}}>
                  {this.state.legacyData?.epa_coaching_text['header']['name']}
                </div>
              </>
            )}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'stretch',
              gap: '20px',
              height: '100%',
              marginTop: "10px"}}>
              {this.state.conversationMeeting && (
                <MeetingPrintPaceSection
                  tableHead={this.state.conversationMeeting?.meetingPace?.currentUser?.fullName}
                  epaCoachingText={this.state.conversationMeeting?.meetingPace?.epa_coaching_text}
                  meetingPace={this.state.conversationMeeting?.meetingPace?.meeting_pace}
                  defaultPaceColors={this.state.conversationMeeting?.meetingPace?.defaultPaceColors}
                />
              )}
              {this.state.conversationMeeting && (
                <MeetingPrintPaceSection
                  tableHead={this.state.conversationMeeting?.meetingPace?.selectedUser?.fullName}
                  epaCoachingText={this.state.conversationMeeting?.meetingPace?.epa_coaching_text}
                  meetingPace={this.state.conversationMeeting?.meetingPace?.meeting_pace_selected}
                  defaultPaceColors={this.state.conversationMeeting?.meetingPace?.defaultPaceColors}
                />
              )}
              {!this.state.conversationMeeting && (
                <MeetingPrintPaceSection
                    tableHead={this.state.legacyData?.currentUser?.fullName}
                    epaCoachingText={this.state.legacyData?.epa_coaching_text}
                    meetingPace={this.state.legacyData?.meeting_pace}
                    defaultPaceColors={this.state.legacyData?.defaultPaceColors}
                />
              )}
              {!this.state.conversationMeeting && (
                <MeetingPrintPaceSection
                    tableHead={this.state.legacyData?.selectedUser?.fullName}
                    epaCoachingText={this.state.legacyData?.epa_coaching_text}
                    meetingPace={this.state.legacyData?.meeting_pace_selected}
                    defaultPaceColors={this.state.legacyData?.defaultPaceColors}
                />
              )}
            </div>
          </>
        )}
        {meeting.type != 1 && (
          <div className="publishMeetingAttendee">
            <div className="printMeetingAttendeeTitle">{t("ATTENDEES")}</div>
            <div className="attendeeWidth">
              {meeting_invitees.map(
                (invitee, index) =>
                  invitee.access == '1' && (
                    <div className="attendeeDetails">
                      <div className="attendee_print-img">
                        <img
                          src={invitee.picture}
                          className="fitProfileImage goal-user-picture attendeePrintPic roundFramePhoto"
                        />
                      </div>
                      <div className="printAttendeeName">
                        {invitee.user_name}
                      </div>
                    </div>
                  )
              )}
            </div>
          </div>
        )}
      </div>
      </ConnectedOkrManager>
    )
  }
}

export default hot(withTranslation()(MeetingPrintViewComp))
